import LayoutContainer from "../../components/Containers/LayoutContainer";
import '@fortawesome/fontawesome-free/css/all.min.css';
import React from "react"
import "./aboutAsOne.scss";

const AboutAsOne: React.FunctionComponent = () => {

    return (
      <LayoutContainer title="aboutAsOne">
        <div className=" page-header d-flex align-items-center justify-content-left dashboard-container h-100">
         <h2>
          <i className="page-header-icon fa fa-flask">
            
          </i>
          Edit Event
         </h2>
  
        </div>
      </LayoutContainer>
    );
  };
  

export default AboutAsOne;